// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Uruguay from '../_raw/flag/icon_flag_uruguay.png';

export default () => <img src={Uruguay} alt="Uruguay" />;
